import Vue from "vue";
import Vuex from "vuex";
import {amountOfBooksDeliveredForAllDpPdf, publisherBooksXlsx} from "./service";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        navigationItems: [],
        copyDistPointsModal: false,
        loadingModal: false,
        loginModal: false,
        errorPopup: false,
        errorPopupProps: {
            title: 'Σφάλμα!',
            text: 'error',
            color: 'error',
            class: 'white--text error text-center justify-center',
            icon: 'error',
            successStyle:false,
            fontStyleBig:false,
        },
        homePageInformation: {},
	    prefectures:[],
        bookInfoAlert: false,
        publisherBooks: [],
        editPublisherBook: {},
        academicYears: {},
        years: {},
        yearsFixed: [],
        activeYear: '',
        editedYear: '',
        bookFileModal: false,
        bookVolumeModal: false,
        bookHistoryModal: false,
        allDistPoint: [],
        distPointSelected: [],
        distributionAvailability: [],
        libraryOrder: [],
        libraryInfoModal: false,
        actionLibraryModal: false,
        selectedBook: [],
        selectedFullDialog: false,
        selectedDistPoint: {},
        fileUpload: false,
        participationModal: false,
        licenseModal: false,
        bookAllocatorFileModal: false,
        courier: [],
        publisherHistory: false,
        pricingHistory: false,
        distributionStatus: {},
        amountOfSelectedBooksPDF: {},
        amountOfSelectedBooksXLSX: {},
        deliveredBooksPDF: {},
        deliveredBooksXLSX: {},
        booksDistributionXLSX: {},
        homeDeliveryXLSX: {},
        homeDeliveryXLSX1: {},
        amountOfBooksDeliveredForAllDpPdf: {},
        amountOfBooksDeliveredForAllDpXlsx: {},
        amountOfBooksDeliveredPerDpPdf: {},
        amountOfBooksDeliveredPerDpXlsx: {},
        publisherBooksXlsx: {},
        publisherSelectedBooksXlsx: {},
        publisherBooksFromCourierDeliveredXlsx: {},
        publisherBooksFromCourierDeliveredPdf: {},
        publisherLibraryOrdersDeliveredXlsx: {},
        publisherLibraryOrdersDeliveredPdf: {},
        publisherLibraryOrdersXlsx: {},
        publisherLibraryOrdersPdf: {},
        publisherStatementAndDeliveryStatsReport: {},
        confirmModal: false,
        pricingModal: false,
        textAndPercentageDialog: false,
        distPointInfoDialog: false,

    },

    getters: {
        navigationItems: state => state.navigationItems,
        copyDistPointsModal: state => state.copyDistPointsModal,
        loadingModal: state => state.loadingModal,
        loginModal: state => state.loginModal,
        errorPopup: state => state.errorPopup,
        errorPopupProps: state => state.errorPopupProps,
        homePageInformation: state => state.homePageInformation,
	    prefectures: state => state.prefectures,
        bookInfoAlert: state => state.bookInfoAlert,
        publisherBooks: state => state.publisherBooks,
        editPublisherBook: state => state.editPublisherBook,
        academicYears: state => state.academicYears,
        bookFileModal: state => state.bookFileModal,
        bookVolumeModal: state => state.bookVolumeModal,
        bookHistoryModal: state => state.bookHistoryModal,
        allDistPoint: state => state.allDistPoint,
        distPointSelected: state => state.distPointSelected,
        distributionAvailability: state => state.distributionAvailability,
        years: state => state.years,
        yearsFixed: state => state.yearsFixed,
        activeYear: state => state.activeYear,
        editedYear: state => state.editedYear,
        libraryOrder: state => state.libraryOrder,
        libraryInfoModal: state => state.libraryInfoModal,
        actionLibraryModal: state => state.actionLibraryModal,
        selectedBook: state => state.selectedBook,
        selectedFullDialog: state => state.selectedFullDialog,
        selectedDistPoint: state => state.selectedDistPoint,
        fileUpload: state => state.fileUpload,
        participationModal: state => state.participationModal,
        licenseModal: state => state.licenseModal,
        bookAllocatorFileModal: state => state.bookAllocatorFileModal,
        courier: state => state.courier,
        publisherHistory: state => state.publisherHistory,
        pricingHistory: state => state.pricingHistory,
        distributionStatus: state => state.distributionStatus,
        amountOfSelectedBooksPDF: state => state.amountOfSelectedBooksPDF,
        amountOfSelectedBooksXLSX: state => state.amountOfSelectedBooksXLSX,
        deliveredBooksPDF: state => state.deliveredBooksPDF,
        deliveredBooksXLSX: state => state.deliveredBooksXLSX,
        booksDistributionXLSX: state => state.booksDistributionXLSX,
        homeDeliveryXLSX: state => state.homeDeliveryXLSX,
        homeDeliveryXLSX1: state => state.homeDeliveryXLSX1,
        amountOfBooksDeliveredForAllDpPdf: state => state.amountOfBooksDeliveredForAllDpPdf,
        amountOfBooksDeliveredForAllDpXlsx: state => state.amountOfBooksDeliveredForAllDpXlsx,
        amountOfBooksDeliveredPerDpPdf: state => state.amountOfBooksDeliveredPerDpPdf,
        amountOfBooksDeliveredPerDpXlsx: state => state.amountOfBooksDeliveredPerDpXlsx,
        publisherBooksXlsx: state => state.publisherBooksXlsx,
        publisherSelectedBooksXlsx: state => state.publisherSelectedBooksXlsx,
        publisherBooksFromCourierDeliveredXlsx: state => state.publisherBooksFromCourierDeliveredXlsx,
        publisherBooksFromCourierDeliveredPdf: state => state.publisherBooksFromCourierDeliveredPdf,
        publisherLibraryOrdersDeliveredXlsx: state => state.publisherLibraryOrdersDeliveredXlsx,
        publisherLibraryOrdersDeliveredPdf: state => state.publisherLibraryOrdersDeliveredPdf,
        publisherLibraryOrdersXlsx: state => state.publisherLibraryOrdersXlsx,
        publisherLibraryOrdersPdf: state => state.publisherLibraryOrdersPdf,
        publisherStatementAndDeliveryStatsReport: state => state.publisherStatementAndDeliveryStatsReport,
        confirmModal: state => state.confirmModal,
        pricingModal: state => state.pricingModal,
        textAndPercentageDialog: state => state.textAndPercentageDialog,
        distPointInfoDialog: state => state.distPointInfoDialog,

    },
    mutations: {
        setNavigationItems: function (state, navigationItemsData) {
          state.navigationItems = navigationItemsData
        },
        setCopyDistPointsModal: function (state , copyDistPointsModalData) {
            state.copyDistPointsModal = copyDistPointsModalData
        },
        setLoadingModal: function (state, loadingModalData) {
            state.loadingModal = loadingModalData
        },
        setloginModal: function(state, loginModalData){
            state.loginModal = loginModalData
        },
        setErrorPopup: function (state , errorPopupData){
            state.errorPopup = errorPopupData;
        },
        setBookInfoAlert: function (state , data){
            state.bookInfoAlert = data;
        },
        setErrorPopupProps: function (state , errorPopupPropsData){
            state.errorPopupProps = errorPopupPropsData;
        },
        setHomePageInformation: function (state, homePageInformationData) {
            state.homePageInformation = homePageInformationData
        },
	    setPrefectures: function (state, data) {
            state.prefectures = data
        },
        setPublisherBooks: function (state, publisherBooksData) {
            state.publisherBooks = publisherBooksData
        },
        setEditPublisherBook: function (state, editPublisherBookData) {
            state.editPublisherBook = editPublisherBookData
        },
        setAcademicYears: function (state, academicYearsData) {
            state.academicYears = academicYearsData
        },
        setActiveYear: function (state , activeYearData) {
            state.activeYear = activeYearData;
        },
        setEditedYear: function (state , editedYearData) {
            state.editedYear = editedYearData;
        },
        setBookFileModal: function (state, bookFileModalData) {
            state.bookFileModal = bookFileModalData
        },
        setBookVolumeModal: function (state, bookVolumeModalData) {
            state.bookVolumeModal = bookVolumeModalData
        },
        setBookHistoryModal: function (state, bookHistoryModalData) {
            state.bookHistoryModal = bookHistoryModalData
        },
        setAllDistPoint: function (state, allDistPointData) {
            state.allDistPoint = allDistPointData
        },
        setDistPointSelected: function (state, distPointSelectedData) {
            state.distPointSelected = distPointSelectedData
        },
        setDistributionAvailability: function (state, distributionAvailabilityData) {
            state.distributionAvailability = distributionAvailabilityData
        },
        setYears: function (state, yearsData) {
            state.years = yearsData
        },
        setYearsFixed: function (state, data) {
            state.yearsFixed = data
        },
        setLibraryOrder: function (state, libraryOrderData) {
            state.libraryOrder = libraryOrderData
        },
        setLibraryInfoModal: function (state, libraryInfoModalData) {
            state.libraryInfoModal = libraryInfoModalData
        },
        setActionLibraryModal: function (state, actionLibraryModalData) {
            state.actionLibraryModal = actionLibraryModalData
        },
        setSelectedBook: function (state, selectedBookData) {
            state.selectedBook = selectedBookData
        },
        setSelectedFullDialog: function (state, selectedFullDialogData) {
            state.selectedFullDialog = selectedFullDialogData
        },
        setSelectedDistPoint: function (state, selectedDistPointData) {
            state.selectedDistPoint = selectedDistPointData
        },
        setFileUpload: function (state, fileUploadData) {
            state.fileUpload = fileUploadData
        },
        setParticipationModal: function (state, participationModalData) {
            state.participationModal = participationModalData
        },
        setLicenseModal: function ( state, licenseModalData) {
            state.licenseModal = licenseModalData
        },
        setBookAllocatorFileModal: function (state, bookAllocatorFileModalData) {
            state.bookAllocatorFileModal = bookAllocatorFileModalData
        },
        setCourier: function (state, courierData) {
            state.courier = courierData
        },
        setPublisherHistory: function (state, publisherHistoryData) {
            state.publisherHistory = publisherHistoryData
        },
        setPricingHistory: function (state, data) {
            state.pricingHistory = data
        },
        setDistributionStatus: function (state, distributionStatusCallBack) {
            state.distributionStatus = distributionStatusCallBack
        },
        setAmountOfSelectedBooksPDF: function( state, amountOfSelectedBooksPDFData){
          state.amountOfSelectedBooksPDF = amountOfSelectedBooksPDFData
        },
        setAmountOfSelectedBooksXLSX: function (state, amountOfSelectedBooksXLSXData) {
            state.amountOfSelectedBooksXLSX = amountOfSelectedBooksXLSXData
        },
        setDeliveredBooksPDF: function(state, deliveredBooksPDFData){
          state.deliveredBooksPDF = deliveredBooksPDFData
        },
        setDeliveredBooksXLSX: function (state, deliveredBooksXLSXData) {
            state.deliveredBooksXLSX = deliveredBooksXLSXData
        },
        setDooksDistributionXLSX: function (state, booksDistributionXLSXData) {
            state.booksDistributionXLSX = booksDistributionXLSXData
        },
        setHomeDeliveryXLSX: function (state, homeDeliveryXLSXData) {
            state.homeDeliveryXLSX = homeDeliveryXLSXData
        },
        setHomeDeliveryXLSX1: function (state, homeDeliveryXLSXData) {
            state.homeDeliveryXLSX1 = homeDeliveryXLSXData
        },
        setAmountOfBooksDeliveredForAllDpPdf: function (state, amountOfBooksDeliveredForAllDpPdfData) {
            state.amountOfBooksDeliveredForAllDpPdf = amountOfBooksDeliveredForAllDpPdfData;
        },
        setAmountOfBooksDeliveredForAllDpXlsx: function (state, amountOfBooksDeliveredForAllDpXlsxData) {
            state.amountOfBooksDeliveredForAllDpXlsx = amountOfBooksDeliveredForAllDpXlsxData;
        },
        setAmountOfBooksDeliveredPerDpPdf: function (state , amountOfBooksDeliveredPerDpPdfData) {
            state.amountOfBooksDeliveredPerDpPdf = amountOfBooksDeliveredPerDpPdfData;
        },
        setAmountOfBooksDeliveredPerDpXlsx: function (state , amountOfBooksDeliveredPerDpXlsxData) {
            state.amountOfBooksDeliveredPerDpXlsx = amountOfBooksDeliveredPerDpXlsxData;
        },
        setPublisherBooksXlsx: function (state , publisherBooksXlsxData) {
            state.publisherBooksXlsx = publisherBooksXlsxData;
        },
        setPublisherSelectedBooksXlsx: function (state , publisherSelectedBooksData) {
            state.publisherSelectedBooksXlsx = publisherSelectedBooksData;
        },
        setPublisherBooksFromCourierDeliveredXlsx: function (state , publisherBooksFromCourierDeliveredXlsxData) {
            state.publisherBooksFromCourierDeliveredXlsx = publisherBooksFromCourierDeliveredXlsxData ;
        },
        setPublisherBooksFromCourierDeliveredPdf: function (state , publisherBooksFromCourierDeliveredPdfData) {
            state.publisherBooksFromCourierDeliveredPdf = publisherBooksFromCourierDeliveredPdfData ;
        },
        setPublisherLibraryOrdersDeliveredXlsx: function (state , publisherLibraryOrdersDeliveredXlsxData) {
            state.publisherLibraryOrdersDeliveredXlsx = publisherLibraryOrdersDeliveredXlsxData;
        },
        setPublisherLibraryOrdersDeliveredPdf: function (state , publisherLibraryOrdersDeliveredPdfData) {
            state.publisherLibraryOrdersDeliveredPdf = publisherLibraryOrdersDeliveredPdfData;
        },
        setPublisherLibraryOrdersXlsx: function (state , publisherLibraryOrdersXlsxData) {
            state.publisherLibraryOrdersXlsx = publisherLibraryOrdersXlsxData;
        },
        setPublisherLibraryOrdersPdf: function (state , publisherLibraryOrdersPdfData) {
            state.publisherLibraryOrdersPdf = publisherLibraryOrdersPdfData;
        },
        setPublisherStatementAndDeliveryStatsReport: function (state, publisherStatementAndDeliveryStatsReportData) {
            state.publisherStatementAndDeliveryStatsReport = publisherStatementAndDeliveryStatsReportData;
        },
        setConfirmModal: function (state, data) {
            state.confirmModal = data
        },
        setPricingModal: function (state, pricingModalData) {
            state.pricingModal = pricingModalData
        },
        setTextAndPercentageDialog: function (state, data) {
            state.textAndPercentageDialog = data
        },
        setDistPointInfoDialog: function (state, data) {
            state.distPointInfoDialog = data
        },
    },
    actions: {},
    modules: {}
});
